import React, { PureComponent, Fragment } from 'react';
import { withApi } from '../../context/AppContext';
import './UIPanel.css';

import SideBar from '../../components/SideBar';
import TabContent from '../TabContent';

class UIPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.filteredItems = [
      'base',
      'depth',
      'width',
      'feetAndCasters',
      'workSurface',
    ];
  }

  getTabs = () => {
    const { appApi, configuration } = this.props;
    for (let idx = 0; idx < this.filteredItems.length; ++idx)
      if (!configuration[this.filteredItems[idx]].value)
        return [appApi.config.getTab('start')];
    return appApi.config.getTab();
  };

  render() {
    const { appApi } = this.props;
    if (!appApi) return <div className="configuration-not-loaded" />;
    const tabs = this.getTabs();
    return (
      <Fragment>
        <TabContent />
        <SideBar tabs={tabs} {...this.props} />
      </Fragment>
    );
  }
}

export default withApi(UIPanel);



// WEBPACK FOOTER //
// ./src/containers/UIPanel/index.js